// Team content — structured for future external CMS (Sanity / WordPress REST API).
// No biographies, qualifications or affiliations until supplied.
export const teamMembers = [
  { id: "praveen-rajaram", name: "Praveen Rajaram", role: "Founder", order: 1 },
  { id: "prashanth-r", name: "Prashanth Rajaram", role: "Co-Founder", order: 2 },
  { id: "dr-pradeep-krishna", name: "Dr. Pradeep Krishna", role: "Founding Member · Veterinary Doctor", order: 3 },
  { id: "dr-balangouda-m-patil", name: "Dr. Balangouda M Patil", role: "Founding Member · Veterinary Doctor", order: 4 },
  { id: "sreeja", name: "Sreeja", role: "Founding Member · Education & Community Engagement", order: 5 },
];
